function coorps_reducer(state = [], action) {
    switch (action.type) {
        case 'COORPS/SET':            
            return action.coorps;
        case 'COORPS/CLEAR':
            return null;
        default:
            return state;
    }
}

export default coorps_reducer;
